<script setup>
import { computed } from 'vue';
import ChannelIcon from 'dashboard/components-next/icon/ChannelIcon.vue';

const props = defineProps({
  inbox: {
    type: Object,
    default: () => {},
  },
});

const INBOX_COLOR_CLASSES = [
  'bg-n-blue-3 text-n-blue-11 ring-n-blue-4',
  'bg-n-teal-3 text-n-teal-11 ring-n-teal-4',
  'bg-n-amber-3 text-n-amber-12 ring-n-amber-5',
  'bg-n-ruby-3 text-n-ruby-11 ring-n-ruby-4',
  'bg-n-iris-2 text-n-iris-11 ring-n-iris-4',
];

const inboxColorClass = computed(() => {
  const id = Number(props.inbox?.id || 0);
  return INBOX_COLOR_CLASSES[id % INBOX_COLOR_CLASSES.length];
});
</script>

<template>
  <div :title="inbox.name" class="flex items-center gap-0.5 min-w-0">
    <ChannelIcon :inbox="inbox" class="size-3 flex-shrink-0 text-n-slate-11" />
    <span
      class="max-w-24 truncate rounded-md px-1 py-0 text-xxs font-medium leading-4 ring-1"
      :class="inboxColorClass"
    >
      {{ inbox.name }}
    </span>
  </div>
</template>
